// extracted by mini-css-extract-plugin
module.exports = {"tickerName":"styles_tickerName__Y249i"};